import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'agogiGorgoteri';
const args = { color: CssVars.ColorAgogi };

export class AgogiGorgoteri extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
